import { Directive } from '@angular/core';

@Directive({
	selector: '[appBottomSheet]',
})
export class BottomSheetDirective {
	constructor() {}
}
